import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PBtn } from "./ui";
import QuoteDocument, { QuoteSnapshot } from "./quote-document";
import { downloadQuotePdf } from "./quote-pdf";

export default function QuoteModal({ show, onHide, snapshot, autoDownload = false }: {
  show: boolean; onHide: () => void; snapshot: QuoteSnapshot; autoDownload?: boolean;
}) {
  const { t } = useTranslation("supplierPricing");
  const source = useRef<HTMLDivElement>(null);
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const autoStarted = useRef(false);
  const documentReady = useCallback(() => setReady(true), []);
  const [error, setError] = useState(false);
  const download = useCallback(async () => {
    if (!source.current || pending.current) return;
    pending.current = true; setBusy(true); setError(false);
    try { await downloadQuotePdf(source.current, snapshot.quote_no); }
    catch { setError(true); }
    finally { pending.current = false; setBusy(false); }
  }, [snapshot.quote_no]);
  useEffect(() => {
    if (show && ready && autoDownload && !autoStarted.current) {
      autoStarted.current = true; void download();
    }
  }, [show, ready, autoDownload, download]);
  return <Modal show={show} onHide={onHide} centered size="xl" dialogClassName="eb-pr eb-quote-modal">
    <div className="eb-quote-toolbar">
      <PBtn onClick={download} disabled={busy}>{busy ? t("common.loading") : t("quote.download")}</PBtn>
      <PBtn kind="secondary" onClick={onHide}>{t("common.close")}</PBtn>
    </div>
    {error && <p role="alert">{t("quote.downloadFailed")}</p>}
    <div className="eb-quote-viewport"><div ref={source}><QuoteDocument snapshot={snapshot} onReady={documentReady} /></div></div>
  </Modal>;
}
